/**
 * Component: Video Embed
 * Description: 
 *
 * Usage:
 *   - Automatically initialises on page load.
 *
 * Notes:
 * 
 */

export function videoEmbeds(videos) {
    if (!videos) {
        return;
    }

    function getVideoConfig(provider, videoId) {
        switch (provider) {
            case 'youtube':
            return {
                src: `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&rel=0&playsinline=1`,
                allow: 'autoplay; fullscreen; picture-in-picture'
            };

            case 'vimeo':
            default:
            return {
                src: `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&controls=1&title=0&byline=0&autopause=false`,
                allow: 'autoplay; fullscreen; picture-in-picture'
            };
        }
    }

    videos.forEach((embed) => {
        const playButton = embed.querySelector('.video-embed__play');
        const media = embed.querySelector('.video-embed__media');

        const videoId = embed.dataset.videoId;
        const provider = embed.dataset.videoType || 'vimeo';

        playButton.addEventListener('click', () => {
            playButton.disabled = true;

            const { src, allow } = getVideoConfig(provider, videoId);

            const iframe = document.createElement('iframe');
            iframe.src = src;
            iframe.allow = allow;
            iframe.allowFullscreen = true;
            iframe.setAttribute('frameborder', '0');

            media.appendChild(iframe);

            iframe.addEventListener('load', () => {
                embed.classList.add('is-playing');
            });
        });
    });
}